const REPEATING_FREQUENCY_QUARTERLY = 3;
const REPEATING_FREQUENCY_ANNUALLY = 12;

const options = {
  'daily': 'Daily',
  'monthly': 'Monthly',
  'weekly': 'Weekly',
  'do-not-repeat': 'Does not repeat'
};

/**
 * Returns text for repeating column for document management tables -> Daily, Every 3 days, Every 3 weeks etc
 * @param period schedule report period
 * @param repeatingFrequency frequency for dispatching reports according to period type
 */
export const getPeriodText = (period: 'do-not-repeat' | 'daily' | 'weekly' | 'monthly', repeatingFrequency: number) => {
  if (repeatingFrequency === 1) {
    return options[period];
  }

  if (repeatingFrequency === 0) {
    return 'Does not repeat';
  }

  if (repeatingFrequency === REPEATING_FREQUENCY_QUARTERLY && period === 'monthly') {
    return 'Quarterly';
  }

  if (repeatingFrequency === REPEATING_FREQUENCY_ANNUALLY && period === 'monthly') {
    return 'Annually';
  }

  return `Every ${repeatingFrequency} ${period === 'daily' ? 'days' : period === 'weekly' ? 'weeks' : 'months'}`;
};
